import i18n, { ResourceLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import cs from '~/services/i18n/cs.json';
import da from '~/services/i18n/da.json';
import de from '~/services/i18n/de.json';
import en from '~/services/i18n/en.json';
import es from '~/services/i18n/es.json';
import fi from '~/services/i18n/fi.json';
import fr from '~/services/i18n/fr.json';
import it from '~/services/i18n/it.json';
import lv from '~/services/i18n/lv.json';
import nl from '~/services/i18n/nl.json';
import no from '~/services/i18n/no.json';
import pl from '~/services/i18n/pl.json';
import sv from '~/services/i18n/sv.json';
import tr from '~/services/i18n/tr.json';
import hu from '~/services/i18n/hu.json';
import lt from '~/services/i18n/lt.json';

const defaultNS = 'translation';

export interface LanguageResource extends ResourceLanguage {
  translation: Record<string, any>;
  languageName: string;
}

export type LanguageCode =
  | 'cs'
  | 'da'
  | 'de'
  | 'en'
  | 'es'
  | 'fi'
  | 'fr'
  | 'it'
  | 'lv'
  | 'nl'
  | 'no'
  | 'pl'
  | 'sv'
  | 'tr'
  | 'hu'
  | 'lt';

export const resources: Record<LanguageCode, LanguageResource> = {
  cs: {
    translation: cs,
    languageName: 'Čeština',
  },
  da: {
    translation: da,
    languageName: 'Dansk',
  },
  de: {
    translation: de,
    languageName: 'Deutsch',
  },
  en: {
    translation: en,
    languageName: 'English',
  },
  es: {
    translation: es,
    languageName: 'Español',
  },
  fi: {
    translation: fi,
    languageName: 'Suomi',
  },
  fr: {
    translation: fr,
    languageName: 'Français',
  },
  it: {
    translation: it,
    languageName: 'Italiano',
  },
  lv: {
    translation: lv,
    languageName: 'Latviešu',
  },
  nl: {
    translation: nl,
    languageName: 'Nederlands',
  },
  no: {
    translation: no,
    languageName: 'Norsk bokmål',
  },
  pl: {
    translation: pl,
    languageName: 'Polski',
  },
  sv: {
    translation: sv,
    languageName: 'Svenska',
  },
  tr: {
    translation: tr,
    languageName: 'Türkçe',
  },
  hu: {
    translation: hu,
    languageName: 'Magyar',
  },
  lt: {
    translation: lt,
    languageName: 'Lietuvių',
  },
} as const;

export function configLocales() {
  i18n.use(initReactI18next).init({
    resources,
    ns: defaultNS,
    defaultNS,
    fallbackLng: 'en',
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['ol', 'li', 'ul', 'p'],
    },
  });
  return i18n;
}
